export const userEventSearchOptions = [
  { name: 'event', label: 'Event' },
  { name: 'label', label: 'Label' }
];
